import * as React from 'react'
import { Message, Segment } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

type ConfirmRegisterPageProps = {
  user?: IUser,
  error: boolean,
  message?: string,
}

export const ConfirmRegisterPage: React.SFC<ConfirmRegisterPageProps> = ({user, error, message}) => {
  return (
    <div style={{paddingTop: -10}}>
    <Segment>
    <div className="container" style={{height: 300, fontSize: 20}}>
      {error &&
      <Message error={true}>
        <Message.Header>
          Xác thực email không thành công
        </Message.Header>
        <Message.Content>
          {message}
          <br/>
          Quay về <Link color={'white'} to={'/pick'}>Trang chủ</Link>.
        </Message.Content>
      </Message>}
      {!error && user &&

      <Message success={true}>
        <Message.Header>
          Xác thực email thành công!
        </Message.Header>
        <Message.Content>
          Chúc mừng <strong>{user.username}</strong>! Bạn đã xác thực email thành công!
          Xin hãy đăng nhập để sử dụng Ezvalue.vn!
          <br/>
          Quay về <Link color={'white'} to={'/pick'}>Trang chủ</Link>.
        </Message.Content>
      </Message>}
    </div>
    </Segment>
    </div>
  )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Auth/components/ConfirmRegisterPage.tsx